<template>
    <div>
        <div class="movie-box acea-row color-text movie-search-wrapper" :style="searchStyle">
            <div class="page-relative movie-search-left" @click="clickCity" :style='searchCityStyle'>
                <span class="city">{{city}}</span>▼
            </div>
            <div class="movie-search-content">
                <form @submit.prevent action="" class="page-relative">
                    <span class="iconfont icon-xiazai5 page-absolute search-icon"></span>
                    <input type="search" ref="input" :placeholder="placeholderText" v-model.trim="searchMovie"  @keydown.enter="searchInfo"/>
                    <span class="search-text" @click="searchInfo">搜索</span>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
import cookie from "@utils/store/cookie";

const LONGITUDE = "user_longitude";
const LATITUDE = "user_latitude";
const MAPKEY = "mapKey";

export default {
    name:"MovieSearch",
    props: {
      placeholderText: {
          type: String,
          default: ""
      },
      searchCityStyle: {
          type: Object,
          default: ()=>{}
      },
      searchStyle: {
          type: Object,
          default: ()=>{}
      },
      city: {
          type: String,
          default: ""
      },
      isClear: {
          type: Boolean,
          default: false
      }
    },
    watch: {
        isClear: function (val) {
            if (val) {
                this.clearSearchText();
            }
        }
    },
    data: function() {
        return {
            searchMovie: ""
        }
    },
    mounted:function(){
        // console.log("搜索看信息", this.city);
    },
    methods:{
        clearSearchText: function () {
            this.searchMovie = "";
        },
        clickCity: function () {
            this.$emit("clickCity");
        },
        searchInfo: function() {
            // console.log("点击搜索",this.searchMovie);
            this.$refs.input.blur();
            this.$emit('getSearchInfo', this.searchMovie);
        }
    }
}
</script>

<style scoped>
.color-text {
    color:white;
}
.movie-search-wrapper{
    height:1.1rem;
    padding:.3rem;
}
.movie-search-left{
    min-width: 1rem;
    height:100%;
    box-sizing: border-box;
    /* padding-right:.4rem; */
    min-width:1rem;
}
.city{
   font-size:.3rem;
}
.movie-search-content{
    flex:1;
    height:100%;
    line-height:.5rem;
    min-width: 3.9rem;
}
.iconfont{
    margin-right:.2rem;
}
.movie-search-content form{
    height: 100%;
    background:rgba(255, 255, 255, .5);
    border-radius:.4rem;
}
.movie-search-content input {
    width: 75%;
    height: 100%;
    padding-left: .8rem;
}
input::-webkit-input-placeholder {
    color: white;
}
input::-moz-input-placeholder {
    color: white;
}
input::-ms-input-placeholder {
    color: white;
}
input::-o-input-placeholder {
    color: white;
}
.movie-search-content .search-text{
    padding-left: .2rem;
    border-left: .02rem solid #ccc;
}
.search-icon {
    left: .26rem;
    top: .01rem;
}
</style>
